import GrantApprovalClause from './GrantApprovalClause'

export default GrantApprovalClause
